import { render, staticRenderFns } from "./stepDetails.vue?vue&type=template&id=63132b30"
import script from "./stepDetails.ts?vue&type=script&lang=js&external"
export * from "./stepDetails.ts?vue&type=script&lang=js&external"
import style0 from "./stepDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports